import queryString from "query-string";
import {currentBreakpoint} from "Helpers/BreakpointHelper";

export const Image = (_image) => {
  return _image.UmbracoFile ? _image.UmbracoFile : null;
};

export const GetBackgroundPositionCoordinates = (source) => {
  const subStr = new URL(
    window.location.origin + window.location.pathname + source
  ).search.substring(1);

  const parsed = queryString.parse(subStr);
  const { rxy } = parsed;

  const y =
    rxy !== undefined ? rxy.split(",")[1] * 100 : -1;
  const x =
    rxy !== undefined ? rxy.split(",")[0] * 100 : -1;

  const coordinates = x !== -1 && { x: x, y: y, mode: rxy };

  return coordinates;
};

export const getResponsiveImage = (props) => {
  if (props != undefined && !Array.isArray(props)) {
    const { Desktop, Ipad, Mobile } = props;

    switch (currentBreakpoint()) {
      case "mobile":
        return Mobile;
      case "desktop":
        return Desktop;
      case "ipad":
        return Ipad;
      default:
        return Desktop;
    }
  } else {
    const size = currentBreakpoint();
    return props?.map((image) => {
      const { Desktop, Ipad, Mobile } = image;
      switch (size) {
        case "mobile":
          return Mobile;
        case "desktop":
          return Desktop;
        case "ipad":
          return Ipad;
        default:
          return Desktop;
      }
    });
  }
};
